import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Line } from 'react-chartjs-2'
import { unitFetchAll } from '../../actions/unitAction'
import { AvForm, AvInput } from 'availity-reactstrap-validation'
import { muatanTerbanyak } from '../../actions/dashboardAction'
import { jenisbarangFetchAll } from '../../actions/jenisbarangAction'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { Row, Col, Card, CardHeader, CardBody, Button, FormGroup, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'

let isDefaultJenisBarang = false
let isDefaultTahun = false
let isDefaultSatuan = false

class MuatanTerbanyak extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start: 0,
      curPage: 1,
      perPage: 5,
      jenis_barang: '',
      jenis_barang_label: '',
      tahun: '',
      date_start: '',
      date_end: '',
      satuan: '',
      satuan_label: ''
    }

    this.selectJenisBarang = this.selectJenisBarang.bind(this)
    this.selectTahun = this.selectTahun.bind(this)
    this.selectSatuan = this.selectSatuan.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      length: 5
    }

    this.props.muatanTerbanyak(data)
    this.props.jenisbarangFetchAll()
    this.props.unitFetchAll()
  }

  componentWillUnmount() {
    isDefaultJenisBarang = false
    isDefaultTahun = false
    isDefaultSatuan = false
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        jenis_barang: this.state.jenis_barang,
        tahun: this.state.tahun,
        date_start: this.state.date_start,
        date_end: this.state.date_end,
        satuan: this.state.satuan
      }

      if (this.state.curPage === undefined) {
        data.start = this.state.start
      } else {
        let offset = (this.state.curPage * 5) - 5
        data.start = offset
      }

      this.props.muatanTerbanyak(data)
    }
  }

  selectJenisBarang(opt) {
    if (opt) {
      this.setState({
        jenis_barang: opt.value,
        jenis_barang_label: opt.label
      })
    } else {
      this.setState({
        jenis_barang: '',
        jenis_barang_label: ''
      })
    }
  }

  selectTahun(opt) {
    if (opt) {
      this.setState({ tahun: opt.value })
    } else {
      this.setState({ tahun: '' })
    }
  }

  selectSatuan(opt) {
    if (opt) {
      this.setState({
        satuan: opt.value,
        satuan_label: opt.label
      })
    } else {
      this.setState({
        satuan: '',
        satuan_label: ''
      })
    }
  }

  handleClick(e) {
    this.setState({ curPage: e })
  }

  handleFilter(event, values) {
    if (this.state.jenis_barang) {
      values.jenis_barang = this.state.jenis_barang
      isDefaultJenisBarang = true
    } else {
      delete values.jenis_barang
      isDefaultJenisBarang = false
    }

    if (this.state.tahun) {
      values.tahun = this.state.tahun
      isDefaultTahun = true
    } else {
      delete values.tahun
      isDefaultTahun = false
    }

    if (this.state.satuan) {
      values.satuan = this.state.satuan
      isDefaultSatuan = true
    } else {
      delete values.satuan
      isDefaultSatuan = false
    }

    this.setState({
      date_start: values.date_start,
      date_end: values.date_end
    })

    values.length = this.state.perPage

    this.props.muatanTerbanyak(values)
  }

  renderData() {
    if (this.props.muatanTerbanyakIsSuccess) {
      let defaultValues = {
        jenis_barang: this.state.jenis_barang,
        jenis_barang_label: this.state.jenis_barang_label,
        satuan: this.state.satuan,
        satuan_label: this.state.satuan_label,
        tahun: this.state.tahun,
        date_start: this.state.date_start,
        date_end: this.state.date_end
      }

      const prevPage = parseInt(this.props.muatanTerbanyakData.currentPage) - 1
      const nextPage = parseInt(this.props.muatanTerbanyakData.currentPage) + 1

      let curPage = this.props.muatanTerbanyakData.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2

      const pages = []
      const totalPages = this.props.muatanTerbanyakData.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      const { jenis_barang } = this.state.jenis_barang
      const { tahun } = this.state.tahun
      const { satuan } = this.state.satuan
      const defaultValueJenisBarang = { label: defaultValues.jenis_barang_label, value: defaultValues.jenis_barang }
      const defaultValueTahun = { label: defaultValues.tahun, value: defaultValues.tahun }
      const defaultValueSatuan = { label: defaultValues.satuan_label, value: defaultValues.satuan }

      let muatanTerbanyakData = this.props.muatanTerbanyakData.data
      let labels = []
      let data = []

      muatanTerbanyakData.forEach(val => {
        let arrLabel = val.nama_barang + ' (' + val.satuan + ')'
        let arrData = val.total

        labels.push(arrLabel)
        data.push(arrData)
      })

      const line_muatan = {
        labels: labels,
        datasets: [
          {
            fill: true,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 5,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: data,
          },
        ],
        option_line: {
          legend: {
            display: false
          },
          tooltips: {
            enabled: false
          }
        }
      }

      const options_line = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        legend: {
          display: false,
        },
        maintainAspectRatio: false
      }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>5 Jenis Muatan Terbanyak Per Prioritas</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Select name="tahun"
                        value={tahun}
                        isClearable
                        placeholder="Tahun..."
                        defaultValue={isDefaultTahun ? defaultValueTahun : false}
                        onChange={this.selectTahun}
                        options={this.props.muatanTerbanyakData.tahun}
                        id="tahun"
                        inputId="input_tahun"
                        instanceId="instance_tahun"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Dari</InputGroupText>
                        </InputGroupAddon>
                        <AvInput type="date" name="date_start" />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Sampai</InputGroupText>
                        </InputGroupAddon>
                        <AvInput type="date" name="date_end" />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  {this.props.jenisbarangIsSuccess &&
                    <Col md="4">
                      <FormGroup >
                        <Select name="jenis_barang"
                          value={jenis_barang}
                          isClearable
                          placeholder="Jenis Barang..."
                          defaultValue={isDefaultJenisBarang ? defaultValueJenisBarang : false}
                          onChange={this.selectJenisBarang}
                          options={this.props.jenisbarang.data}
                          id="jenis_barang"
                          inputId="input_jenis_barang"
                          instanceId="instance_jenis_barang"
                        />
                      </FormGroup>
                    </Col>
                  }
                  {this.props.unitIsSuccess &&
                    <Col md="4">
                      <FormGroup >
                        <Select name="satuan"
                          value={satuan}
                          isClearable
                          placeholder="Satuan..."
                          defaultValue={isDefaultSatuan ? defaultValueSatuan : false}
                          onChange={this.selectSatuan}
                          options={this.props.units.data}
                          id="satuan"
                          inputId="input_satuan"
                          instanceId="instance_satuan"
                        />
                      </FormGroup>
                    </Col>
                  }
                  <Col md="4" className="align-self-end">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1">
                        <i className="fa fa-search"></i> <span>Proses </span>
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody>
              <div className="chart-wrapper">
                <Line data={line_muatan} options={options_line} />
              </div>
            </CardBody>
          </Card>
        </div>
      )
    }
  }

  render() {
    if (this.props.muatanTerbanyakIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.muatanTerbanyakHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }
}

MuatanTerbanyak.propTypes = {
  muatanTerbanyakIsSuccess: PropTypes.bool.isRequired,
  muatanTerbanyakHasError: PropTypes.bool.isRequired,
  muatanTerbanyakIsLoading: PropTypes.bool.isRequired,

  jenisbarangIsSuccess: PropTypes.bool.isRequired,
  jenisbarangHasError: PropTypes.bool.isRequired,
  jenisbarangIsLoading: PropTypes.bool.isRequired,

  unitIsSuccess: PropTypes.bool.isRequired,
  unitHasError: PropTypes.bool.isRequired,
  unitIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    muatanTerbanyakData: state.dashboard.muatanTerbanyakData,
    muatanTerbanyakIsSuccess: state.dashboard.muatanTerbanyakSuccess,
    muatanTerbanyakHasError: state.dashboard.muatanTerbanyakError,
    muatanTerbanyakIsLoading: state.dashboard.muatanTerbanyakLoading,

    jenisbarangIsSuccess: state.jenisbarangs.jenisbarangGetSuccess,
    jenisbarangHasError: state.jenisbarangs.jenisbarangGetError,
    jenisbarangIsLoading: state.jenisbarangs.jenisbarangGetLoading,
    jenisbarang: state.jenisbarangs.jenisbarangs,

    units: state.units.units,
    unitIsSuccess: state.units.unitGetSuccess,
    unitHasError: state.units.unitGetError,
    unitIsLoading: state.units.unitGetLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    muatanTerbanyak: (data) => dispatch(muatanTerbanyak(data)),
    jenisbarangFetchAll: () => dispatch(jenisbarangFetchAll()),
    unitFetchAll: () => dispatch(unitFetchAll())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MuatanTerbanyak)